<template>
<div style="background-color:#e0f2f1;margin-top:0px">
    <v-card flat>
        <v-container>
            <div class="row">
                <div class="col-lg-9 col-md-9 col-sm-12">
                    <h1>{{title}}</h1>
                    <p style="text-align:justify;font-size:17px;padding-top:15px;" class="txt" v-html="description" >
                    </p>
                    <a :href=brochureSrc target="_blank">
                      <v-btn v-if="brochureSrc!=null" depressed color="#383838" dark>Download E-brochure</v-btn>
                    </a>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <img style="height:200px;width:100%;" class="center" :src=src />
                </div>
            </div>
        </v-container>
    </v-card>
</div>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
      isLoading: false,
      title: sessionStorage.blogTitle,
      description: sessionStorage.blogDescription,
      src: sessionStorage.blogSrc,
      brochureSrc: sessionStorage.brochureSrc,
      news: {}
    };
  },

  mounted() {
  }
};
</script>

<style lang="css" scoped>
img.center {
    display: block;
    margin: 0 auto;
}
</style>
